import styles from './styles.module.css';
import Image from '@/shared/components/Image/new';
import { formatAuthorNames } from '@/shared/functions/formatAthorNames'

const AuthorAbajo = (props) => {
    const { author } = props;

    const authorName = formatAuthorNames(author.name);
    const authorBio = author.shortBiography;
    const haveBiography = (author) => {
      return author.shortBiography &&
        !author.shortBiography.includes("<p> </p>")
    }
    
    return (
        <div className={`${styles["author-box"]}`} itemProp="author" itemScope itemType="https://schema.org/Person">
            {author.imageUrl && author.imageUrl !== undefined &&
                <a itemProp="url" href={`/autor/${author.slug}`}>
                    <span className={`${styles["author-logo"]}`}>
                        <Image
                            src={author.imageUrl}
                            alt={author.name}
                            width={80}
                            height={80}
                        />
                    </span>
                </a>
            }
            <a itemProp="url" className={`${styles["author-name-box"]}`} href={`/autor/${author.slug}`} >
             
                <span itemProp="name" className={`${styles["seguir-span"]}`}>
                   {authorName} 
                </span>

                { haveBiography(author) && (
                    <>
                        <div className={styles["separator"]}></div>
                        <div
                            className={styles["author-biografia"]}
                            dangerouslySetInnerHTML={{
                                __html: author.shortBiography
                            }}
                        />
                        
                    </>
                )}
                <div className={styles["author-perfil"]}>Ver Perfil</div>
            </a>

        </div>
    );
}

export default AuthorAbajo;